import React from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import ReactPlayer from "react-player";

import "./video-modal.style.scss";

const VideoModal = (props) => {
  const isInstagram = props.videoUrl?.includes("instagram.com");

  let formattedVideoUrl = props.videoUrl;
  if (isInstagram && formattedVideoUrl) {
    try {
      const urlObj = new URL(formattedVideoUrl);
      urlObj.search = "";
      if (!urlObj.pathname.endsWith("/embed") && !urlObj.pathname.endsWith("/embed/")) {
        urlObj.pathname = urlObj.pathname.replace(/\/$/, "") + "/embed";
      }
      formattedVideoUrl = urlObj.toString();
    } catch (e) {
      console.error("Invalid URL:", e);
    }
  }

  return (
    <Modal
      {...props}
      show={props.show}
      size={isInstagram ? "md" : "xl"}
      centered
      className="video-modal-container"
      backdropClassName="video-modal-backdrop"
      dialogClassName={`video-modal ${isInstagram ? 'instagram-modal' : ''}`}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="player-wrapper">
          {isInstagram ? (
            <iframe
              className="instagram-player"
              src={formattedVideoUrl}
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              allowTransparency="true"
              allow="encrypted-media"
            ></iframe>
          ) : (
            <ReactPlayer
              className="react-player"
              url={props.videoUrl}
              width="100%"
              height="100%"
              controls={true}
              playbackRate={1}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
